import VueCookies from "vue-cookie";

export function getSessionId() {
  return VueCookies.get("SessionId");
}
export function setSessionId(token) {
  return VueCookies.set("SessionId", token);
}
export function removeToken() {
  return VueCookies.delete("SessionId");
}
